export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT LUNCH MENU.2e7026f7.pdf";